export const INPUT_TYPE = {
    INPUT_TEXT : "text",
    INPUT_NUMBER : "number",
    INPUT_RADIO : "radio",
    INPUT_CHECKBOX : "checkbox",
    INPUT_PASSWORD : "password",
}